module.exports = __webpack_public_path__ + "static/media/Resume_TalonJin-Fullstack.c3689312.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/files/Resume_TalonJin-Fullstack.pdf
// module id = 306
// module chunks = 0